/* export const listaTecnologias = [
  {
    category: "Tecnologías Principales",
    technologies: { id: 1, title: "SAP Hybris (Java), SAP SmartEdit, SAP Backoffice" },
  },
  {
    category: "Lenguajes de Programación",
    technologies: { id: 2, title: "Java, Java EE, JavaScript, TypeScript, HTML ,CSS" },
  },
  {
    category: "Frameworks Back-end",
    technologies: [
      { id: 3, title: "Spring,MVC, NodeJs, JSP" },
    ]
  },
  {
    category: "Frameworks Front-end",
    technologies: { id: 14, title: "Angular, ReactJs, VueJs, reshaped, Spartacus, remix, nextjs," }
  },
  {
    category: "Bases de Datos",
    technologies: { id: 21, title: "MySQL, SQLServer, MariaDB" },
  },
  {
    category: "Control de Versiones y Gestión",
    technologies: [
      { id: 24, title: "Git (Bitbucket)" },
      { id: 25, title: "Jira" },
      { id: 26, title: "Figma" }
    ]
  },
  {
    category: "Librerías y Herramientas",
    technologies: [
      { id: 27, title: "Bootstrap" },
      { id: 28, title: "DataTable" },
      { id: 29, title: "Full-Calendar" },
      { id: 30, title: "Fetch" },
      { id: 31, title: "Jquery" },
      { id: 32, title: "Ajax" },
      { id: 33, title: "SweetAlert2" }
    ]
  },
  {
    category: "Tecnologías Adicionales",
    technologies: [
      { id: 34, title: "XML" },
      { id: 35, title: "Impex" },
      { id: 36, title: "less" },
      { id: 37, title: "tag" },
      { id: 38, title: "vm" }
    ]
  }
];
 */

export const listaTecnologias = [
  {
    category: "Tecnologías Principales",
    technologies: {
      id: 1,
      title: "SAP Hybris (Java), SAP SmartEdit, SAP Backoffice",
    },
  },
  {
    category: "Lenguajes de Programación",
    technologies: {
      id: 2,
      title: "Java, Java EE, JavaScript, TypeScript, HTML, CSS",
    },
  },
  {
    category: "Frameworks Back-end",
    technologies: {
      id: 3,
      title: "Spring, MVC, NodeJs, JSP",
    },
  },
  {
    category: "Frameworks Front-end",
    technologies: {
      id: 4,
      title: "Angular, ReactJs, VueJs, reshaped, Spartacus, remix, nextjs",
    },
  },
  {
    category: "Bases de Datos",
    technologies: {
      id: 5,
      title: "MySQL, SQLServer, MariaDB",
    },
  },
  {
    category: "Control de Versiones y Gestión",
    technologies: {
      id: 6,
      title: "Git (Bitbucket), Jira, Figma",
    },
  },
  {
    category: "Librerías y Herramientas",
    technologies: {
      id: 7,
      title: "Bootstrap, DataTable, Full-Calendar, Fetch, Jquery, Ajax, SweetAlert2",
    },
  },
  {
    category: "Tecnologías Adicionales",
    technologies: {
      id: 8,
      title: "XML, Impex, less, tag, vm",
    },
  },
];
